import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onRequest = async (
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> => {
  const cashierBearerToken = 'qqqq';
  if (cashierBearerToken) {
    // @ts-ignore
    config.headers.Authorization = `Bearer ${cashierBearerToken}`;
  }
  return config;
};

const onResponseErrorCashier = async (
  error: AxiosError
): Promise<AxiosError> => {
  if (error.response) {
    if (
      error.response.status === 401 &&
      (error.response.data as { message: string }).message === 'jwt expired'
    ) {
      try {
        const response = await axios.post(`api/v1/secured/token/refresh`, {
          token: 'TOKEN'
        });
        const { token } = response.data;

        if (error.config) {
          const updatedConfig: AxiosRequestConfig = {
            ...error.config,
            headers: {
              ...error.config.headers,
              Authorization: `Bearer ${token}`
            }
          };

          return axios.request(updatedConfig);
        }
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
  }
  return Promise.reject(error);
};

const setupInterceptors = (axiosInstance: AxiosInstance): AxiosInstance => {
  // @ts-ignore
  axiosInstance.interceptors.request.use(onRequest);
  axiosInstance.interceptors.response.use(onResponse, onResponseErrorCashier);
  return axiosInstance;
};

export const appAxios = setupInterceptors(
  axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
      'X-Access-Token': localStorage.getItem('token')
        ? JSON.parse(localStorage.getItem('token') ?? '')
        : ''
    }
  })
);
